module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan2-1-40b945015be078fbe289fb35b5e6fc46.webp";